module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "password-reset-component"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.hasSucceeded) ? _c('el-alert', {
    attrs: {
      "title": "Success",
      "type": "success",
      "description": "Your request to reset your password has been received, please check your mailbox for details."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasFailed) ? _c('el-alert', {
    attrs: {
      "title": "Password Reset Failed",
      "type": "error",
      "description": "We couldn't reset your password. Please contact COLONY LIVE support for further assistance."
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "passwordResetForm",
    staticClass: "password-reset-form",
    attrs: {
      "model": _vm.passwordResetForm,
      "rules": _vm.passwordResetFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isPending,
      "placeholder": "Email"
    },
    model: {
      value: (_vm.passwordResetForm.email),
      callback: function($$v) {
        _vm.$set(_vm.passwordResetForm, "email", $$v)
      },
      expression: "passwordResetForm.email"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "password-reset-btn",
      "type": "primary",
      "loading": _vm.isPending
    },
    on: {
      "click": _vm.onClickResetPassword
    }
  }, [_vm._v("\n        Reset Password\n      ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Already have an account?")])], 1)], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-purple"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logos/logo-white-live.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-icon",
    attrs: {
      "src": "static/assets/icons/auth/lock.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey text-white text-center welcome-message"
  }, [_c('h4', [_vm._v("Password Recovery")]), _vm._v(" "), _c('p', [_vm._v("\n        Sorry to hear you forgot your password. "), _c('br'), _vm._v("Please provide the email address for the account you wish to reset.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f2b809a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/auth/PasswordResetForm.vue
// module id = 3239
// module chunks = 3